// extracted by mini-css-extract-plugin
export default {"loader":"YKsQOR2kSwuJMTk7yS4m"};